import React from 'react';
import { ShieldCheck, ChevronRight } from 'lucide-react';
import { trackEvent } from '../hooks/useMetaPixel';
export function OfferSection() {
  return <section id="offer" className="py-24 px-4 sm:px-6 lg:px-8 bg-[#0D0D1A] relative overflow-hidden" data-id="element-151">
      {/* Background Effects */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gaming-purple/10 blur-[150px] rounded-full pointer-events-none" data-id="element-152" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-153">
        <div className="bg-gaming-bg border-2 border-gaming-purple/40 rounded-3xl p-8 md:p-12 box-glow-purple-strong text-center" data-id="element-154">
          <h2 className="font-orbitron text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-155">
            Obtén el sistema completo <br className="hidden md:block" data-id="element-156" />
            <span className="text-gaming-purple-light text-glow-purple" data-id="element-157">
              Plan de Acción Para Pasar de Jugador a Streamer
            </span>{' '}
            hoy mismo.
          </h2>

          <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-158">
            Por el precio de una skin de juego, obtendrás las herramientas
            exactas para que tu hobby empiece a pagar tus cuentas.
          </p>

          <div id="offer-price" className="mb-10" data-id="element-159">
            <span className="text-gray-400 uppercase tracking-widest text-sm font-bold mb-2 block" data-id="element-160">
              Pago Único
            </span>
            <div className="flex flex-col items-center justify-center gap-3" data-id="element-161">
              <span className="text-2xl md:text-3xl font-orbitron text-white/70 line-through decoration-red-500 decoration-2" data-id="element-162">
                $19.99
              </span>
              <div className="flex items-center gap-4" data-id="element-163">
                <span className="text-6xl md:text-8xl font-orbitron font-black text-white text-glow-purple tracking-tighter" data-id="element-164">
                  $6.39
                </span>
                <span className="bg-green-500 text-white font-orbitron font-bold text-sm md:text-base px-3 py-1.5 rounded-md uppercase tracking-wider animate-pulse" data-id="element-165">
                  68% OFF
                </span>
              </div>
            </div>
          </div>

          <a href="https://flexiofertas.com/cart/50710433202462:1" target="_blank" rel="noopener noreferrer" onClick={() => trackEvent('AddToCart', {
          content_name: 'Plan de Acción Para Pasar de Jugador a Streamer',
          value: 6.39,
          currency: 'USD'
        })} className="w-full md:w-auto group relative inline-flex items-center justify-center px-10 py-5 font-orbitron font-bold text-white text-lg md:text-xl uppercase tracking-widest bg-gaming-purple hover:bg-gaming-purple-light transition-all duration-300 rounded-sm box-glow-purple-strong hover:scale-105 mb-6" data-id="element-166">
            <span data-id="element-167">¡Sí, quiero empezar mi imperio ahora!</span>
            <ChevronRight className="ml-2 w-6 h-6 group-hover:translate-x-2 transition-transform" data-id="element-168" />
          </a>

          <div className="flex flex-col items-center justify-center space-y-3 text-sm text-gray-400" data-id="element-169">
            <div className="flex items-center" data-id="element-170">
              <ShieldCheck className="w-5 h-5 text-green-400 mr-2" data-id="element-171" />
              <span data-id="element-172">Pago 100% Seguro y Encriptado</span>
            </div>
            <p data-id="element-173">⚡ Acceso inmediato tras la compra.</p>
          </div>
        </div>
      </div>
    </section>;
}